module.exports = __webpack_public_path__ + "img/banner_SmartPark.234c6278.png";